const getLoadingStatus = state => state.connectorValues.isLoading;

const getSelectOptions = state => state.connectorValues.selectOptions;

export { getLoadingStatus, getSelectOptions };
